import { createAsyncThunk, createSlice, isAnyOf } from '@reduxjs/toolkit';
import moment from 'moment';
import { requestApi } from '../../common/apiRequest';
import { Admin, LoginRequest } from './types';
import { applicationApi } from '../../common/api';

export const authLogin = createAsyncThunk('auth/login', async (data: LoginRequest) => {
  const response = await requestApi('POST', 'auth/login', data);
  return response.data;
});

export const authLogout = createAsyncThunk('auth/logout', async () => {
  const response = await requestApi('POST', 'auth/logout');
  return response.data;
});

export const whoAmI = createAsyncThunk('auth/whoami', async () => {
  const response = await requestApi('GET', 'auth/whoami');
  return response.data;
});

export const authSlice = createSlice({
  name: 'auth',
  initialState: {
    admin: null,
    avatar: '',
    isAuthenticated: false,
    status: 'idle',
    error: null,
    timestamp: 0,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(authLogin.pending, whoAmI.pending), (state, action) => {
      state.status = 'loading';
      state.isAuthenticated = false;
      state.timestamp = 0;
    });
    builder.addMatcher(isAnyOf(authLogin.fulfilled, whoAmI.fulfilled), (state, action) => {
      state.status = 'success';
      state.admin = action.payload;
      state.isAuthenticated = true;
      let username = (action.payload as Admin).username;
      state.avatar = `https://avatars.dicebear.com/api/identicon/${username}.svg`;
      state.timestamp = moment().valueOf();
    });
    builder.addMatcher(isAnyOf(authLogin.rejected, whoAmI.rejected), (state, action: any) => {
      state.status = 'failed';
      state.admin = null;
      state.error = action.message;
      state.isAuthenticated = false;
      state.avatar = '';
      state.timestamp = 0;
    });
  },
});

// Define a service using a base URL and expected endpoints
export const profileApi = applicationApi.injectEndpoints({
  endpoints: (builder) => ({
    updateProfile: builder.mutation<void, any>({
      query: (body) => ({
        url: '/auth/profile',
        method: 'PATCH',
        body,
      }),
    }),
    updatePassword: builder.mutation<void, any>({
      query: (body) => ({
        url: '/auth/password',
        method: 'PATCH',
        body,
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useUpdateProfileMutation, useUpdatePasswordMutation } = profileApi;
